import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { toast } from 'sonner';
import { Send, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/** Sendet die Onboarding-Einladung erneut an einen bestehenden Mitarbeiter
 *  (E-Mail + WhatsApp, in der hinterlegten Sprache). */
export const EmployeeInviteResendButton = ({ userId, asMenuItem = false }) => {
  const [sending, setSending] = useState(false);

  const resend = async () => {
    setSending(true);
    try {
      const r = await axios.post(`${API}/employee-onboarding/${userId}/resend`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const sent = r.data?.sent || {};
      if (sent.email || sent.whatsapp) {
        const ch = [sent.email && 'E-Mail', sent.whatsapp && 'WhatsApp'].filter(Boolean).join(' & ');
        toast.success(`Einladung gesendet (${ch}).`);
      } else {
        navigator.clipboard?.writeText(r.data?.onboarding_link || '');
        toast.info('Kein Versandkanal aktiv — Link in die Zwischenablage kopiert.');
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Senden fehlgeschlagen.');
    } finally { setSending(false); }
  };

  if (asMenuItem) {
    return (
      <DropdownMenuItem
        onSelect={(e) => { e.preventDefault(); resend(); }}
        disabled={sending}
        data-testid={`employee-invite-resend-${userId}`}
      >
        {sending ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Send size={14} className="mr-2" />}
        Einladung
      </DropdownMenuItem>
    );
  }

  return (
    <Button variant="ghost" size="sm" onClick={resend} disabled={sending} data-testid={`employee-invite-resend-${userId}`}>
      {sending ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Send size={14} className="mr-1.5" />}
      Einladung
    </Button>
  );
};
